import React from 'react';
import s from './Refollow.module.scss';

export function collectRefollowSourceBatches(rows) {
  const map = new Map();
  (rows || []).forEach((row) => {
    const id = row?.source_batch_id ?? row?.ops_batch_id;
    if (!id || map.has(id)) return;
    map.set(id, {
      id,
      name: row?.source_batch_name,
      description: row?.source_batch_description,
    });
  });
  return [...map.values()].sort((a, b) => a.id - b.id);
}

export default function RefollowSourceBatchChip({
  opsBatchId,
  name,
  description,
  stacked = false,
  filterActive = false,
  onFilterToggle = null,
}) {
  const id = opsBatchId;
  const label = (name || '').trim();
  if (!id && !label) return null;
  const hover = [
    id ? `CM batch #${id}` : '',
    label,
    (description || '').trim(),
    onFilterToggle ? 'Click to filter' : '',
  ].filter(Boolean).join('\n');

  if (stacked) {
    return (
      <span className={s.cmBatchCell} title={hover}>
        {id ? <span className={s.cmBatchId}>{`#${id}`}</span> : null}
        {label ? <span className={s.cmBatchName}>{label}</span> : null}
      </span>
    );
  }

  const chipClass = [
    s.refollowSourceChip,
    onFilterToggle ? s.refollowSourceChipBtn : '',
    filterActive ? s.refollowSourceChipActive : '',
  ].filter(Boolean).join(' ');

  if (onFilterToggle) {
    return (
      <button
        type="button"
        className={chipClass}
        title={hover}
        aria-pressed={filterActive}
        onClick={(e) => {
          e.stopPropagation();
          onFilterToggle(id);
        }}
      >
        {id ? <span className={s.refollowSourceChipOpsId}>{`#${id}`}</span> : null}
        {label ? <span className={s.refollowSourceChipName}>{label}</span> : null}
      </button>
    );
  }

  return (
    <span className={chipClass} title={hover}>
      {id ? <span className={s.refollowSourceChipOpsId}>{`#${id}`}</span> : null}
      {label ? <span className={s.refollowSourceChipName}>{label}</span> : null}
    </span>
  );
}
